"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewSwitch = void 0;

var _react = _interopRequireDefault(require("react"));

var _router = require("../../router");

var _Page = _interopRequireDefault(require("../../views/Page404/Page404"));

var _config = require("../../config");

var _security = require("../../utils/security");

var _RedirectToFirstMenu = require("../RedirectToFirstMenu");

var _NotificationUtils = require("../../utils/NotificationUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ViewSwitch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ViewSwitch, _React$Component);

  function ViewSwitch() {
    _classCallCheck(this, ViewSwitch);

    return _possibleConstructorReturn(this, _getPrototypeOf(ViewSwitch).apply(this, arguments));
  }

  _createClass(ViewSwitch, [{
    key: "getDisplayName",
    // TODO: check if it working
    value: function getDisplayName(params) {
      return this.props.translate(params);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          user = _this$props.user,
          translate = _this$props.translate;

      var routes = _config.Config.get("router", "routes");

      var routeComponents = routes.map(function (_ref, key) {
        var path = _ref.path,
            exact = _ref.exact,
            component = _ref.component,
            children = _ref.children,
            title = _ref.title,
            access = _ref.access,
            directTabLink = _ref.directTabLink;
        var Component = component;

        if (access && !(0, _security.canAccess)(user, access)) {
          return _react["default"].createElement(_router.Route, {
            key: key,
            path: path,
            exact: exact,
            component: function component() {
              var txt = translate('security/accessToPageForbidden/userRedirected');
              (0, _NotificationUtils.showWarning)(txt.replace("${page}", translate(title)), 1000 * 5);
              return _react["default"].createElement(_RedirectToFirstMenu.RedirectToFirstMenu, null);
            },
            getDisplayName: _this.getDisplayName.bind(_this, title)
          });
        }

        return _react["default"].createElement(_router.Route, {
          key: key,
          path: path,
          exact: exact,
          render: function render(props) {
            return _react["default"].createElement(Component, _extends({
              directTabLink: directTabLink
            }, props));
          },
          getDisplayName: _this.getDisplayName.bind(_this, title)
        }, children);
      });
      return _react["default"].createElement(_router.Switch, null, routeComponents, _react["default"].createElement(_router.Route, {
        path: "*",
        component: _Page["default"]
      }));
    }
  }]);

  return ViewSwitch;
}(_react["default"].Component);

exports.ViewSwitch = ViewSwitch;